// Ensure you have the necessary imports for your environment
// import { Pathnames } from 'next-intl/navigation';

export const locales = ['en', 'fr'];

export const pathnames = {
  '/': '/',
  '/pathnames': {
    en: '/pathnames',
    fr: '/pfadnamen'
  }
}; 

// Use the default: `always`
export const localePrefix = undefined;

export const AppPathnames = Object.keys(pathnames);
